// extracted by mini-css-extract-plugin
module.exports = {"container":"Modal_container__1UxXY","header":"Modal_header__1ZN6d","title":"Modal_title__3HrFl","crossIcon":"Modal_crossIcon__zBVPd","shadow":"Modal_shadow__GFbN1"};